import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { NativeAudio } from 'ionic-native';

/*
  Generated class for the SmartAudio provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class SmartAudio {

  audioType: string = 'html5';
  sounds: any = [];
 
  constructor(platform: Platform) {
    if(platform.is('cordova')){
      this.audioType = 'native';
    }
  }
 
  preload(key, asset) {
    if(this.audioType === 'html5'){
      let audio = {
        key: key,
        asset: asset,
        type: 'html5'
      };
      this.sounds.push(audio);
    } else {
      NativeAudio.preloadSimple(key, asset);
      let audio = {
        key: key,
        asset: key,
        type: 'native'
      };
      
      this.sounds.push(audio);
    }       
  }
  play(key) {
    
    let audio = this.sounds.find((sound) => {
      return sound.key === key;
    });
    
    if(audio.type === 'html5'){
      
      let audioAsset = new Audio(audio.asset);
      audioAsset.play();
      let promise = new Promise((resolve,reject) => {
        audioAsset.addEventListener('playing', () => {
          resolve(true);
        });
        audioAsset.addEventListener('error', () => {
          reject(false);
        });
      });
      return promise;

    } else {
      let promise = NativeAudio.play(audio.asset);
      return promise;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/smart-audio.ts